import React from "react";

const Navbar = () => {
  return (
    <div>
      <header>
        <div className="container">
          <div className="d-flex flex-wrap align-items-center header-content">
            <div className="logo">
              <a href="/" title="">
                <img
                  src="assets/img/logo3.png"
                  alt=""
                  srcSet="assets/img/logo3.png"
                  style={{ width: "70px", height: "80px" }}
                />
              </a>
            </div>
            {/*logo end*/}
            <ul className="d-flex flex-wrap contact-add">
              <li>
                <div className="contact-info">
                  <img src="assets/img/icon1.png" alt="" />
                  <div className="contact-tt">
                    <h4>Call</h4>
                    <span>+2 342 5446 67</span>
                  </div>
                </div>
                {/*contact-info end*/}
              </li>
              <li>
                <div className="contact-info">
                  <img src="assets/img/icon2.png" alt="" />
                  <div className="contact-tt">
                    <h4>Work Time</h4>
                    <span>Mon - Fri 8 AM - 5 PM</span>
                  </div>
                </div>
                {/*contact-info end*/}
              </li>
              <li>
                <div className="contact-info">
                  <img src="assets/img/icon3.png" alt="" />
                  <div className="contact-tt">
                    <h4>Address</h4>
                    <span>Franklin St, Greenpoint Ave</span>
                  </div>
                </div>
                {/*contact-info end*/}
              </li>
            </ul>
            {/*contact-information end*/}
            <div className="menu-btn">
              <a href="#">
                <span className="bar1" /> <span className="bar2" />{" "}
                <span className="bar3" />
              </a>
            </div>
            {/*menu-btn end*/}
          </div>
          {/*header-content end*/}
          <div className="d-flex flex-wrap navigation-bar align-items-center">
            <nav>
              <ul>
                <li>
                  <a className="active" href="/" title="">
                    Home
                  </a>
                </li>
                <li>
                  <a href="/about" title="">
                    About
                  </a>
                  <ul>
                    <li>
                      <a href="/events" title="">
                        Events
                      </a>
                    </li>
                    <li>
                      <a href="/event-single" title="">
                        Event Single
                      </a>
                    </li>
                    <li>
                      <a href="/schedule" title="">
                        Schedule
                      </a>
                    </li>
                    {/* <li>
                    <a href="error.html" title="">
                      404
                    </a>
                  </li> */}
                  </ul>
                </li>
                <li>
                  <a href="/classes" title="">
                    Classes
                  </a>
                  <ul>
                    <li>
                      <a href="/class-single" title="">
                        Class Single
                      </a>
                    </li>
                  </ul>
                </li>
                {/*<li>
                <a href="teachers" title="">
                  Teachers
                </a>
                <ul>
                  <li>
                    <a href="teacher-single.html" title="">
                      Teacher Single
                    </a>
                  </li>
                </ul>
              </li> */}
                <li>
                  <a href="/blog" title="">
                    Blog
                  </a>
                  <ul>
                    <li>
                      <a href="/post" title="">
                        Blog Single
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a href="/contact" title="">
                    Contacts
                  </a>
                </li>
              </ul>
            </nav>
            {/*nav end*/}
            <ul className="ml-auto social-links">
              <li>
                <a href="#" title="">
                  <i className="fa-facebook-f fab" />
                </a>
              </li>
              <li>
                <a href="#" title="">
                  <i className="fa-linkedin-in fab" />
                </a>
              </li>
              <li>
                <a href="#" title="">
                  <i className="fa-instagram fab" />
                </a>
              </li>
            </ul>
          </div>
          {/*navigation-bar end*/}
        </div>
      </header>
      {/*header end*/}
      <>
        <div className="responsive-menu">
          <ul>
            <li>
              <a href="index.html" title="">
                Home
              </a>
            </li>
            <li>
              <a href="about.html" title="">
                About
              </a>
            </li>
            <li>
              <a href="events.html" title="">
                Events
              </a>
            </li>
            <li>
              <a href="event-single.html" title="">
                Event Single
              </a>
            </li>
            <li>
              <a href="schedule.html" title="">
                Schedule
              </a>
            </li>
            <li>
              <a href="classes.html" title="">
                Classes
              </a>
            </li>
            <li>
              <a href="class-single.html" title="">
                Classe Single
              </a>
            </li>
            <li>
              <a href="teachers.html" title="">
                Teachers
              </a>
            </li>
            <li>
              <a href="teacher-single.html" title="">
                Teacher Single
              </a>
            </li>
            <li>
              <a href="blog.html" title="">
                Blog
              </a>
            </li>
            <li>
              <a href="post.html" title="">
                Blog Single
              </a>
            </li>
            <li>
              <a href="contacts.html" title="">
                Contacts
              </a>
            </li>
            <li></li>
          </ul>
        </div>
        {/*responsive-menu end*/}
      </>
    </div>
  );
};

export default Navbar;
